import { DOCUMENT, inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { clearQueryParams } from '@utils/clear-query-params';
import { QUERY_PARAMS } from '@constants/query-params';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private defaultView = inject(DOCUMENT).defaultView;
  private localStorageService = inject(LocalStorageService);

  constructor() {
    this.setTokenFromUrl();
  }

  setToken(token: string): void {
    this.localStorageService.save(QUERY_PARAMS.BEARER_TOKEN, token);
  }

  getToken(): string | null {
    return this.localStorageService.get<string>(QUERY_PARAMS.BEARER_TOKEN);
  }

  removeToken() {
    this.localStorageService.delete(QUERY_PARAMS.BEARER_TOKEN);
  }

  private setTokenFromUrl(): void {
    if (!this.defaultView) return;

    const searchParams = new URLSearchParams(this.defaultView.location.search);
    const token = searchParams.get(QUERY_PARAMS.TOKEN);

    if (!token) {
      return;
    }

    this.setToken(token);
    clearQueryParams(QUERY_PARAMS.TOKEN);
  }
}
